export default {
  clean: () => import("/app/src/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/app/src/layouts/default.vue").then(m => m.default || m),
  "plugin-disclose": () => import("/app/src/layouts/plugin-disclose.vue").then(m => m.default || m),
  sections: () => import("/app/src/layouts/sections.ts").then(m => m.default || m),
  storyblok: () => import("#build/storyblok.vue").then(m => m.default || m)
}